<app-navbar-style-two></app-navbar-style-two>

<div class="inner-banner">
    <div class="container">
        <div class="inner-title text-center">
            <h3>Şartlar ve Koşullar</h3>
            <ul>
                <li><a href="index.html">Ana Sayfa</a></li>
                <li><i class='bx bx-chevron-right'></i></li>
                <li>Şartlar ve Koşullar</li>
            </ul>
        </div>
    </div>

    <div class="inner-banner-shape">
        <div class="shape-one"><img src="assets/img/inner-banner/banner-shape1.png" alt="Images"></div>
        <div class="shape-two"><img src="assets/img/inner-banner/banner-shape2.png" alt="Images"></div>
        <div class="shape-three"><img src="assets/img/inner-banner/banner-shape3.png" alt="Images"></div>
        <div class="inner-banner-dots"><img src="assets/img/shape/dots-shape.png" alt="Images"></div>
    </div>
</div>

<div class="terms-conditions-area pt-50 pb-70">
    <div class="container">
        <div class="single-content">
            <h3>YEOHA Game Studio Şartlar ve Koşullara Hoş Geldiniz</h3>
            <p>Bu web sitesini kullanarak, aşağıda belirtilen şartlar ve koşulları kabul etmiş sayılırsınız. Lütfen bu şartları dikkatlice okuyunuz. YEOHA Game Studio, herhangi bir zamanda bu koşullarda değişiklik yapma hakkını saklı tutar. Güncellenen içerikler web sitesinde yayınlandığı andan itibaren geçerli olacaktır.</p>
            <p>Web sitemizdeki tüm içerik ve hizmetler, bilgi verme amacıyla sunulmaktadır. Kullanıcılar, siteyi yalnızca yasal amaçlarla kullanmayı kabul eder. Üçüncü şahıs haklarına zarar verecek hiçbir işlem yapılamaz.</p>
        </div>
        <div class="single-content">
            <h3>Ürün ve Hizmet Şartları</h3>
            <p>YEOHA Game Studio tarafından sunulan ürün ve hizmetler, açıklamalarında belirtilen kullanım şartları doğrultusunda sunulmaktadır. Ürün veya hizmetin amacı dışında kullanılması yasaktır. Her kullanıcı, hizmetlerden faydalanırken doğruluk, dürüstlük ve iyi niyet esaslarına uygun hareket etmeyi kabul eder.</p>
            <p>Sunulan dijital içerikler ve yazılımlar, YEOHA Game Studio aittir veya lisanslıdır. Tüm telif hakları saklıdır. İzinsiz kopyalama, dağıtım veya ticari amaçla kullanımı yasaktır.</p>
        </div>
        <div class="single-content">
            <h3>Sorumluluk Reddi ve Hizmet Koşulları</h3>
            <p>YEOHA Game Studio, hizmetlerini “olduğu gibi” sunar ve herhangi bir belirli sonucun garanti edilmediğini beyan eder. Web sitesinde yer alan bilgilerin doğruluğu ve güncelliği konusunda azami dikkat gösterilse de, hatalar veya eksiklikler olması durumunda herhangi bir sorumluluk kabul edilmez.</p>
            <p>Siteyi kullanmanızdan kaynaklanan doğrudan veya dolaylı zararlardan YEOHA Game Studio sorumlu tutulamaz. Kullanıcılar, siteyi ve hizmetleri kendi sorumluluğunda kullanır.</p>
        </div>
    </div>
</div>


<!-- <div class="brand-logo-area pt-100">
    <div class="container-fluid">
        <div class="container-max">
            <div class="brand-logo-slider owl-carousel owl-theme">
                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo1.png" alt="Images">
                </div>
                
                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo2.png" alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo3.png" alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo4.png" alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo5.png" alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo6.png" alt="Images">
                </div>
            </div>
        </div>
    </div>
</div> -->

<app-footer-style-two></app-footer-style-two>